import http from "@seims/shared/src/services/HttpService";
export const API_ENDPOINT = `system/user-guides/public`;
export const API_ENDPOINT_VIDEO = `system/video-guides/public`;

const axiosConfigs = {
  AlterBaseURL: false,
};


const getUserGuides = async (moduleName) => {
    const response = http.get(`${API_ENDPOINT}/${moduleName}`);
    return response;
  }

const uploadDocument = async (document, moduleName) => {
  var multiPartHeaders = {
    "Content-Type": "multipart/form-data",
  };

   const response = await http.post(`${API_ENDPOINT}/${moduleName}`, document, {
     headers: multiPartHeaders,
   });
  return  response;
};


export const getVideoUserGuides = async (moduleName) => {
  const { data } = await http.get(`${API_ENDPOINT_VIDEO}/${moduleName}`);
  return data;
};

const downloadFile = async (id) => {
   const response = await http.get(`${API_ENDPOINT}/download/${id}`, {
     responseType: "arraybuffer",
   });
  //  { responseType: 'arraybuffer', ...axiosConfigs })
   return  response;
};

export default {
  uploadDocument,
  getUserGuides,
  downloadFile,
};
